import React from "react";
import Done from "../../../assets/logos/icons/done.png";
import Cancel from "../../../assets/logos/icons/cancel.png";
import { GovoLoading } from "../../../assets/logos";
import "./modal-request.css";
import { useTranslation } from "react-i18next";
import { Dialog } from "@progress/kendo-react-dialogs";

export default function ModalRequst({
  error,
  success,
  isLoading,
  children,
  isModal,
  toggleDialog,
  textError,
}) {
  const { t } = useTranslation();
  const options = {
    success: {
      img: Done,
      text: "La solicitud se completo con éxito",
    },
    error: {
      text: `${textError || ""}`,
      img: Cancel,
    },
    isLoading: {
      img: GovoLoading,
      text: "Ejecutando petición, espere por favor...",
    },
  };

  let currentState = null;
  if (!!success) currentState = options.success;
  if (!!error) currentState = options.error;
  if (!!isLoading) currentState = options.isLoading;
  if (!!currentState) {
    if (!!isModal) {
      return (
        <Dialog
          className="modal-payment-status"
          title={"govo.digital"}
          onClose={toggleDialog}
        >
          <div className="image-request">
            <img src={currentState.img} alt="img-state" />
            <p>{currentState.text}</p>
          </div>
        </Dialog>
      );
    }
    return (
      <div className="image-request">
        <img
          className="img-icon-error"
          src={currentState.img}
          alt="img-error"
        />
        <p>{currentState.text}</p>
      </div>
    );
  } else return children;
}
